import axios from 'axios';
import {
  CUSTOM_COMPONENT_GENERATE_CUSTOM_COMPONENT_BEGIN,
  CUSTOM_COMPONENT_GENERATE_CUSTOM_COMPONENT_SUCCESS,
  CUSTOM_COMPONENT_GENERATE_CUSTOM_COMPONENT_FAILURE,
  CUSTOM_COMPONENT_GENERATE_CUSTOM_COMPONENT_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';


// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function generateCustomComponent(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: CUSTOM_COMPONENT_GENERATE_CUSTOM_COMPONENT_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_AI_ENGINE}v${version}/generate-custom-component`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: CUSTOM_COMPONENT_GENERATE_CUSTOM_COMPONENT_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: CUSTOM_COMPONENT_GENERATE_CUSTOM_COMPONENT_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGenerateCustomComponentError() {
  return {
    type: CUSTOM_COMPONENT_GENERATE_CUSTOM_COMPONENT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CUSTOM_COMPONENT_GENERATE_CUSTOM_COMPONENT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        generateCustomComponentPending: true,
        generateCustomComponentError: null,
      };

    case CUSTOM_COMPONENT_GENERATE_CUSTOM_COMPONENT_SUCCESS:
      // The request is success
      return {
        ...state,
        generateCustomComponentPending: false,
        generateCustomComponentError: null,
      };

    case CUSTOM_COMPONENT_GENERATE_CUSTOM_COMPONENT_FAILURE:
      // The request is failed
      return {
        ...state,
        generateCustomComponentPending: false,
        generateCustomComponentError: action.data.error,
      };

    case CUSTOM_COMPONENT_GENERATE_CUSTOM_COMPONENT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        generateCustomComponentError: null,
      };

    default:
      return state;
  }
}
